//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Mechatronics.js";
import "../Mechatronics/Mechatronics.PhysicsConstraintBuilder.js";
import "../no/Expression.js";
import "../Mechatronics/Mechatronics.SelectRigidBody.js";
import "../no/Expression.js";
import "../no/SelectObject.js";
let d=[[[1,"LowerAngularTrimRange",0,"Expression",0],[1,"LowerOutputRange",0,"Expression",0],[1,"LowerTrimRange",0,"Expression",0],[0,"MeasureType",1,0],[1,"RigidBody",0,"Mechatronics.SelectRigidBody",0],[1,"UpperAngularTrimRange",0,"Expression",0],[1,"UpperOutputRange",0,"Expression",0],[1,"UpperTrimRange",0,"Expression",0],[0,"UseScale",1,0],[0,"UseTrim",1,0]],[],[]];
SPLM.Mechatronics.AccelerometerBuilder = class extends SPLM.Mechatronics.PhysicsConstraintBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Mechatronics.AccelerometerBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Mechatronics.AccelerometerBuilder.OutputMeasureType = Object.freeze({
    "Constant" : "Constant", "Voltage" : "Voltage", "Current" : "Current"});

export default SPLM;